import bsc from "./assets/bsc.png";
import bnb from "./assets/bnb.png";
import jotform from "./assets/jotform.png";
import help from "./assets/help.png";
import linktee from "./assets/linktee.png";
import tel from "./assets/tel.png";
import bgTimer from "./assets/timer-bg.jpg";
import ball from "./assets/ball.png";
import logo from "./assets/logo.png";

import belgium from "./assets/belgium.png";
import brazil from "./assets/brazil.png";
import argentina from "./assets/argentina.png";
import france from "./assets/france.png";
import england from "./assets/england.png";
import us from "./assets/us.png";
import australia from "./assets/australia.png";
import ghana from "./assets/ghana.png";
import switzerland from "./assets/switzerland.png";
import spain from "./assets/spain.png";
import japan from "./assets/japan.png";
import senegal from "./assets/senegal.png";
import portugal from "./assets/portugal.png";
import blinking from "./assets/blinking_new.gif";

const Images = {
   bsc,
   bnb,
   jotform,
   help,
   linktee,
   tel,
   bgTimer,
   ball,
   logo,
   france,
   belgium,
   england,
   argentina,
   brazil,
   us,
   australia,
   ghana,
   switzerland,
   spain,
   japan,
   senegal,
   portugal,
   blinking,
};

export default Images;
